import { createContext } from 'react';
import { IUser } from '../interfaces/user';

type ContextType = {
	userBalance?: number;
	recoverEmailOrPhone: string;
	user: IUser | null;
	permission: string[] | null;
	setPermissions: (val: string[] | null) => void;
	setUserBalance: (balance: number) => void;
	setRecoverEmailOrPhone: (val: string) => void;
	setUser: (user: IUser | null) => void;
};

export const UserContext = createContext<ContextType>({
	userBalance: 0,
	recoverEmailOrPhone: '',
	user: null,
	permission: [],
	setPermissions: () => {},
	setUserBalance: () => {},
	setRecoverEmailOrPhone: () => {},
	setUser: () => {},
});
